import { createFileRoute } from "@tanstack/react-router";

import { defineHead } from "../-common";

import { ServicesPage } from "~/pages/admin-panel";
import { Tk } from "~/shared/i18n";

export const Route = createFileRoute("/{-$locale}/admin-panel/services")({
  head: defineHead({
    titleT: {
      key: Tk.SERVICE,
      options: {
        count: 2,
      },
    },
  }),
  component: ServicesPage,
});
